<template>
    <section>
        <section class="search-container">
            <a-form layout="inline" class="m-t-14">
                <a-form-item label="出入口名称">
                    <a-input class="search-input" v-model="searchInfo.doorwayName" placeholder="请输入" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" class="m-r-8" @click="search"><a-icon type="search" />查询</a-button>
                    <a-button @click="reset"><a-icon type="reload" />重置</a-button>
                    <a-button class="item" @click="exprotFile('exportCarLogList', {params: searchInfo})" style="margin-left: 8px">
                        <a-icon type="export" />
                        导出
                    </a-button>
                   
                </a-form-item>
            </a-form>
        </section>

        <!-- <a-row type="flex" :gutter="20" class="list-card-container" v-if="listMap.length">

            <a-col :span="6" v-for="(item,key) in listMap" :key="key" class="m-t-16">
                <a-row class="list-card-bg">
                    <a-row class="list-wrap">
                        <a-col>
                            <a-row class="list-item" style="padding-bottom:44px">
                                出入口名称：{{item.doorwayName}}
                            </a-row>
                            
                            <a-row class="list-btn-group-position" style="right:0">
                                <router-link :to="{path:'/pcms/car/outInArchives/details',query:{id:item.id}}"><a-button size="small">查看明细</a-button></router-link>
                            </a-row>
                        </a-col>
                    </a-row>
                   
                </a-row>
            </a-col>
        </a-row> -->
        <section class="list-table-container m-t-18" v-if="listMap.length">
            <a-table size="small" :columns="columns" :data-source="listMap" :pagination="{total,pageSize,hideOnSinglePage:true}">
                <a slot="action" slot-scope="text,list">
                     <router-link :to="{path:'/pcms/car/outInArchives/details',query:{id:list.id}}">查看明细</router-link>
                    <!-- <a class="m-r-10" @click="showTypeModal(list)">查看明细</a>
                    <a-popconfirm title="确定删除该车辆类型?" @confirm="deleteItem(list.id)">删除</a-popconfirm> -->
                </a>
                
            </a-table>
        </section>
        <empty v-else :height="430" />
        <!-- <section class="pagination-container">
            <a-pagination size="default" :pageSize="pageSize" :current="pageNum" :total="total"  hide-on-single-page @change="changePageNum" />
        </section> -->
    </section>
    
</template>

<script>
const columns = [
    {title:'序号',dataIndex:'key',align:'center',key:'key'},
    {title:'出入口名称',dataIndex:'doorwayName',align:'center',key:'doorwayName'},
    {title:'出入时间',dataIndex:'createTime',align:'center',key:'createTime'},
    {title:'操作',align:'center',scopedSlots:{customRender: "action"}}
]
import empty from '@/components/empty'
import { exprotFile } from '@/until/unit'
export default {
    data(){
        return{
            columns,
            total:0,
            pageNum:1,
            pageSize:10,
            listMap:[],
            searchInfo:{},
        }
    },
    components:{empty},
    created(){
        this.queryCarInletOutletList()
    },
    methods:{
        exprotFile,
        //查询出入口档案列表
        queryCarInletOutletList(){
            let params = {...this.searchInfo}
            params.current = this.pageNum
            params.doorwayType = 1
            params.size =this.pageSize
            this.$api.queryCarInletOutletList(params).then(res =>{
                if(res.code === 200){
                    this.listMap = (res.data && res.data.records) || []
                    this.listMap.forEach((item,ind) =>{
                        item.key = ind+ 1
                    })
                    this.total = (res.data && res.data.total) || 0
                }
            })
        },
        reset(){
            this.searchInfo = {}
            this.pageNum = 1
            this.queryCarInletOutletList()
        },
        search(){
            this.pageNum = 1
            this.queryCarInletOutletList()
        },
        changePageNum(p){
            this.pageNum = p
            this.queryCarInletOutletList()
        }
    }
}
</script>